/**
 * YUGOMANIAC — custom.js v5.0
 * Vanilla JS only — no jQuery dependency.
 * All functionality rewritten to be stable, performant, and error-free.
 */

(function () {
  'use strict';

  // ── Safe DOM ready ──────────────────────────────────────────
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    // ── 1. Back to Top ────────────────────────────────────────
    var backToTop = document.querySelector('.back-to-top');
    if (backToTop) {
      backToTop.style.display = 'none';
      window.addEventListener('scroll', function () {
        backToTop.style.display = window.scrollY > 300 ? 'flex' : 'none';
      }, { passive: true });
      backToTop.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    // ── 2. Nav submenu toggle (mobile) ────────────────────────
    document.querySelectorAll('.list-menu__item span').forEach(function (span) {
      span.addEventListener('click', function () {
        var item = span.closest('.list-menu__item');
        if (item) item.classList.toggle('active_item');
      });
    });

    // ── 3. Collection grid/list toggle ───────────────────────
    var productGrid = document.getElementById('product-grid');
    if (productGrid) {
      document.querySelector('.product-grid-container')?.classList.add('grid-view-section');

      document.querySelector('.grid-view')?.addEventListener('click', function () {
        this.classList.add('active');
        document.querySelector('.list-view')?.classList.remove('active');
        document.querySelector('.product-grid-container')?.classList.remove('list-view-section1');
        document.querySelector('.product-grid-container')?.classList.add('grid-view-section');
        productGrid.classList.remove('grid--4-col-desktop', 'grid--2-col-tablet-down');
        productGrid.classList.add('grid--2-col-desktop', 'grid--1-col-tablet-down');
      });

      document.querySelector('.list-view')?.addEventListener('click', function () {
        this.classList.add('active');
        document.querySelector('.grid-view')?.classList.remove('active');
        document.querySelector('.product-grid-container')?.classList.remove('grid-view-section');
        document.querySelector('.product-grid-container')?.classList.add('list-view-section1');
        productGrid.classList.remove('grid--2-col-desktop', 'grid--1-col-tablet-down');
        productGrid.classList.add('grid--4-col-desktop', 'grid--2-col-tablet-down');
      });
    }

    // ── 4. Announcement bar auto-rotate (no Flickity needed) ─
    var announceSlider = document.querySelector('.annouce-slider');
    if (announceSlider) {
      var items = announceSlider.querySelectorAll('.annouce-slider__item, .slide');
      if (items.length > 1) {
        var current = 0;
        items.forEach(function (item, i) {
          item.style.display = i === 0 ? '' : 'none';
        });
        setInterval(function () {
          items[current].style.display = 'none';
          current = (current + 1) % items.length;
          items[current].style.display = '';
        }, 4000);
      }
    }

    // ── 5. Countdown timer (if elements exist) ────────────────
    var countdownEl = document.querySelector('[data-countdown]');
    if (countdownEl) {
      var end = new Date(countdownEl.dataset.countdown).getTime();
      if (!isNaN(end)) {
        var tick = function () {
          var diff = Math.max(0, end - Date.now());
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var s = Math.floor((diff % 60000) / 1000);
          countdownEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
          if (diff > 0) setTimeout(tick, 1000);
        };
        tick();
      }
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    // ── 6. Image lazy-load fallback ───────────────────────────
    // Dawn handles this natively; this is just a safety net
    if ('loading' in HTMLImageElement.prototype === false) {
      document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.src = img.dataset.src || img.src;
      });
    }

  }); // end ready

})();
